import { injectIntl } from 'react-intl';
import BookingSearch from './BookingSearch';

export default injectIntl(BookingSearch);
